import Vuex from 'vuex';
import { FirebaseState, firebase } from './firebase';
import { ChatState, chat } from './chat';
import { TemplateState, templates } from './templates';
import { PluginState, plugins } from './plugins';

export interface RootState {
  firebase: FirebaseState;
  chat: ChatState;
  templates: TemplateState;
  plugins: PluginState;
}

export default new Vuex.Store({
  // state: {
  //   created: new Date(), // VueStoreの生成日時、RootStateを空にはできないため設定
  // },
  mutations: {
  },
  modules: {
    firebase,
    chat,
    templates,
    plugins,
  },
});
 

export const getAbsolutePath =
  (isPrivate: boolean, rootState: RootState, relativePath: string): string => {
    if (rootState === undefined) throw new Error('rootState is undefined');
    if (rootState.firebase === undefined)
      throw new Error('rootState.firebase is undefined');
    const firebaseState = rootState.firebase;
    const user = firebaseState.user;
    if (user === undefined)
      throw new Error('user is undefined'); // 全員ログインしているのでこれはありえない
    return `${isPrivate ? `users/${user.uid}/` : ''}${relativePath}`;
  };